import { jsx as s } from "react/jsx-runtime";
import { useMultiStyleConfig as r, Box as o } from "@chakra-ui/react";
import { useAutoSuggestionContext as u } from "./useAutoSuggestionContext.mjs";
const a = ({ ...e }) => {
  const { suggestions: t } = u(), i = r("AutoSuggestion");
  return /* @__PURE__ */ s(o, { role: "status", "aria-live": "polite", ...e, children: t && t.length > 0 && /* @__PURE__ */ s(o, { sx: i.status, children: "Suggestions available. Press up/down arrow keys to access them." }) });
};
export {
  a as AutoSuggestionStatus
};
